import React from 'react'

import { Checkbox, Fieldset } from '@fourthwall/components'

import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'

export const AskForShippingAddress = () => {
  const { form, isLoading } = useTierContext()

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <Checkbox
          label="Ask members for a shipping address during checkout"
          disabled={isLoading || parseFloat(form.values.price) === 0}
          tooltip="Adding a shipping address will be optional. You can find shipping addresses under the Members tab."
          {...form.getFieldProps(FormFields.askForShippingAddress)}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
